import { Link } from "react-router-dom";
import Footer from "../../components/feature/Footer";
import Navbar from "../../components/feature/Navbar";
import { useEffect, useState } from "react";
import { getAboutUs } from "../../api/apiServices";

export default function OurWork() {
    const [about, setAbout] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAbout();
      }, []);


  const fetchAbout = async () => {
      try {
        setLoading(true)
        const res = await getAboutUs();
        if (res?.data) {
          setAbout(res.data);
        } 
      } catch (err) {
        console.error("Failed to fetch about info", err);
        setLoading(false)
      }
    };

  return (
    <div className="min-h-screen bg-white">
        <Navbar />
    
          {/* HERO */}
          <section className="relative pt-20 sm:pt-24">
            <div className="relative h-[400px] sm:h-[500px]">
              <img
                src={about?.image}
                alt={about?.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#6a4bc3]/90 to-[#6a4bc3]/70" />
              <div className="absolute inset-0 flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
                  <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">
                    {about?.ourWork?.description}
                  </h1>
                  {/* <p className="text-white/90 text-base sm:text-lg max-w-2xl">
                    {about?.ourWork?.description}
                  </p> */}
                </div>
              </div>
            </div>
          </section>
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-20 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-[#c9a24d] text-sm font-semibold mb-3">
            OUR WORK
          </p>
        </div>

        {/* GRID */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {about?.ourWork?.items.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm border hover:shadow-md transition"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#6a4bc3]/10 text-[#6a4bc3] text-2xl mb-4">
                <i className={item.icon}></i>
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/donate"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#6a4bc3] text-white font-semibold rounded-full hover:bg-[#5a3ba3] transition shadow-lg"
          >
            Support Our Work
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
    <Footer />
    </div>
    
  );
}
